// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_u3taA","tip":"tip_e-tGw","g-icon":"g-icon","g-icon-suc":"g-icon-suc","g-icon-err":"g-icon-err"};